import { Pipe, PipeTransform } from "@angular/core";

import { CurrencyDisplay, CurrencyDisplayType } from "./currency.model";
import { CurrencyService } from "./currency.service";

@Pipe({
	name: "obgCurrency",
	pure: false,
})
export class ObgCurrencyPipe implements PipeTransform {
	constructor(private service: CurrencyService) {}

	transform(
		value: string | number | null | undefined,
		display?: CurrencyDisplay | CurrencyDisplayType | string,
		currencyCode?: string,
		digitsInfo?: string,
		hideValue?: boolean,
		onlySymbol?: boolean
	): string | null {
		return this.service.format(value, display, currencyCode, digitsInfo, hideValue, onlySymbol);
	}
}
